export const BIRDVIEW_TILE_ROW_SORTABLE_ID = 'birdviewTiles'

export const BIRDVIEW_TILE_ROW_CAROUSEL_MAX_WIDTH = 600

export const BIRDVIEW_TILE_ROW_DEFAULT_COLUMNS = 4
